import { createCardExtraSelectors } from '../lib/createCardExtraSelectors';
export const checkoutCardExtraSelectors = createCardExtraSelectors(state => state.order);
export const checkinCardExtraSelectors = createCardExtraSelectors(state => state.order);
export const createExtraServicesSelectors = (getOrderState) => { };
